// libs
import NFA from 'shared/helpers/analytics/NFAnalytics';

import { PDP_EVENTS } from 'shared/helpers/analytics/constants/pdpEvents';

export const onReferSizeGuideClickTracking = (trackingKey: string) => {
  // todo: remove after omniture removal
  // DTM.track(pdp-refer-size-guide, { sizeguidePosition: trackingKey });

  NFA.track({
    dtmData: { sizeguidePosition: trackingKey },
    event: PDP_EVENTS.SIZE_CHART_CLICK,
  });
};

export const trackSizeGuideChartClosed = () => {
  NFA.track({
    event: PDP_EVENTS.SIZE_CHART_CLOSED,
  });
};
